







































import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import uuid from 'uuid/v4';
import { he } from 'vuejs-datepicker/dist/locale';

@Component({})
export default class DatePickerWidget extends Vue {
  public static readonly DATE_FORMAT: string = 'DD/MM/YYYY';

  @Inject() public $validator: any;

  @Prop(String) public title!: string;
  @Prop(String) public inputName!: string;
  @Prop({ type: String, default: 'payrollForm' }) public formName!: string;
  @Prop(String) public staticInputId!: string;
  @Prop({ type: String, default: 'dd/MM/yyyy' }) public format!: string;
  @Prop(Boolean) public isRequired!: boolean;
  @Prop(Boolean) public monthOnly!: boolean;
  @Prop([Date, Number, String]) public initialDate!: Date | number;
  @Prop(Boolean) public showWarningIcon!: boolean;
  @Prop(Boolean) public showCalendarIcon!: boolean;
  @Prop(Boolean) public isDisabled!: boolean;
  @Prop(Boolean) public clearButton!: boolean;
  @Prop(String) public maximumView!: string;
  @Prop(Boolean) public showClearIcon!: boolean;

  // if set open at this date
  @Prop([Date, Number]) public openAtDate!: Date | number;

  // disable date up to this date - part of disable dates obj
  @Prop([Date, Number]) public disableDateUpTo!: Date | number;

  // disable dates from this date - part of disable dates obj
  @Prop([Date, Number]) public disableDateFrom!: Date | number;

  // disable days of week [0 - 6] - part of disable dates obj
  @Prop(Array) public disableWeekDays!: number[];

  // disable days of week [1 - 31] - part of disable dates obj
  @Prop(Array) public disableMonthsDays!: number[];

  // disable array of specific dates - part of disable dates obj
  @Prop(Array) public disableSpecificDates!: Date[];

  // disable dates range - array of from date to date - part of disable dates obj
  /*{
    from: new Date(2016, 11, 25),
    to: new Date(2016, 11, 30)
  },...*/
  @Prop(Array) public disableDatesRange!: any[];

  public disabledDates: any = {};

  private inputModel: Date | number | string = new Date();
  private inputId: string = '';
  private lang: any = '';
  private htmlName: string = '';

  public created() {
    this.lang = he;
    this.inputId = this.staticInputId || 'input' + uuid();
    this.htmlName = this.inputName || this.$t(this.title).toString();
    if (this.formName && !this.staticInputId) {
      this.inputId = this.formName + '.' + this.inputId;
    }
  }

  public mounted() {
    this.disabledDates = {
      to: this.disableDateUpTo || '',
      from: this.disableDateFrom || '',
      days: this.disableWeekDays || [],
      daysOfMonth: this.disableMonthsDays || [],
      dates: this.disableSpecificDates || [],
      ranges: this.disableDatesRange || [],
    };
    this.inputModel = this.initialDate;
    this.$emit('input', this.inputModel ? this.inputModel : null);
  }

  @Watch('disableDateUpTo')
  public onDisableDateUpToChanged(newVal: any, oldVal: any) {
    this.disabledDates.to = newVal;
  }

  @Watch('disableDateFrom')
  public onDisableDateFromChanged(newVal: any, oldVal: any) {
    this.disabledDates.from = newVal;
  }

  @Watch('disableWeekDays')
  public onDisableWeekDaysChanged(newVal: any, oldVal: any) {
    this.disabledDates.days = newVal;
  }

  @Watch('disableMonthsDays')
  public onDisableMonthsDaysChanged(newVal: any, oldVal: any) {
    this.disabledDates.daysOfMonth = newVal;
  }

  @Watch('disableSpecificDates')
  public onDisableSpecificDatesChanged(newVal: any, oldVal: any) {
    this.disabledDates.dates = newVal;
  }

  @Watch('disableDatesRange')
  public onDisableDatesRangeChanged(newVal: any, oldVal: any) {
    this.disabledDates.range = newVal;
  }

  get validators(): any {
    return {
      required: this.isRequired,
    };
  }

  public updateInputModel(selectedDate: Date): void {
    this.inputModel = selectedDate;
    this.$emit('input', this.inputModel ? this.inputModel : null);
  }

}
